// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"e7c770a0","701":"075114c3"}[chunkId] + ".chunk.css";
};